<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {inputFocusedStore} from '../../stores/inputFocus';

    export let value;
    export let title;
    export let validator = null;
    export let required = false;
    export let active = true;
    let focused = false;
    let inputEl;
    let inputValid = true;


    const dispatch = createEventDispatcher();

    function updateValue() {
        if (validator) {
            inputValid = validateValue();
        } else {
            inputValid = true;
        }
        if (inputValid) {
            dispatch('configValueChanged', value);
        }
    }

    function validateValue(): boolean {
        if (!value && !required) return true;
        return validator(value);
    }

    function onKeyDown(event) {
        if (event.key === 'Enter' && event.shiftKey) {
            updateValue();
            inputEl.blur();
        }
    }

    function onFocus() {
        focused = true;
        inputFocusedStore.set(true);
    }

    function onBlur() {
        focused = false;
        inputFocusedStore.set(false);
    }

    function onKeyPress() {
    }

</script>

<div style="width: 100%" class="flex flex-row bg-center text-input-combination pt-1 w-fit">
    <label class="basis-1/4 text-input-label">{title}: </label>
    {#if active}
        <textarea placeholder="Write text here"
                  class="textarea textarea-ghost {!inputValid ? 'input-error' : ''  } w-full max-w-xs basis-3/4"
                  bind:this="{inputEl}" bind:value={value} on:keypress="{onKeyDown}" on:focus={onFocus} on:blur={onBlur}
                  on:focusout="{updateValue}" on:keypress|stopPropagation={onKeyPress}></textarea>
    {:else }
        <textarea placeholder="Write text here"
                  class="textarea textarea-ghost w-full max-w-xs basis-3/4" disabled></textarea>
    {/if}
</div>
